<script lang="ts">
  import StatusTag from "@kontextwerk/web-sdk/ui/display/StatusTag.svelte"
  import Input from "@kontextwerk/web-sdk/ui/forms/Input.svelte"
  import TableFormCell from "@kontextwerk/web-sdk/ui/layout/TableFormCell.svelte"
  import type { AppointmentPlanningManualAppointmentType } from "../../../../../../../../../../../api/kehrblatt/planning"
  import type {
    PlanningPreviewRow,
    PlanningPreviewRowChange,
  } from "../../../../../../_shared/_logic/table-contract"

  type Props = {
    row: PlanningPreviewRow
    disabled?: boolean
    onChange: (row: PlanningPreviewRow, change: PlanningPreviewRowChange) => void
  }

  const { row, disabled = false, onChange }: Props = $props()

  const options = [
    { label: "Festtermin", value: "HARD" },
    { label: "Flextermin", value: "FLEX" },
  ]

  const labelByValue: Record<AppointmentPlanningManualAppointmentType, string> = {
    HARD: "Festtermin",
    FLEX: "Flextermin",
  }

  const readValue = (event: Event): AppointmentPlanningManualAppointmentType => {
    const detail = (event as CustomEvent<{ value?: unknown }>).detail
    const value =
      typeof detail?.value === "string"
        ? detail.value
        : (event.target as HTMLInputElement | null)?.value

    return value === "FLEX" ? "FLEX" : "HARD"
  }
</script>

{#if row.appointmentTypeEditable}
  <TableFormCell style="min-width: 11.5rem;">
    <Input
      type="select"
      placeholder="Termintyp"
      labelVisibility="hidden"
      {options}
      value={row.appointmentTypeValue}
      brightBackground={true}
      surfaceTone="light"
      classList="appointment-planning-table-select"
      selectStyle="width: 100%; min-width: 0;"
      fitSelectedText={true}
      {disabled}
      onChange={(event) =>
        onChange(row, { kind: "manual_appointment_type", value: readValue(event) })}
    />
  </TableFormCell>
{:else}
  <StatusTag
    variant="neutral"
    size="sm"
    label={labelByValue[row.appointmentTypeValue] ?? "Festtermin"}
    color={row.appointmentTypeValue === "FLEX" ? "cyan" : "blue"}
    disableTitle={true}
  />
{/if}
